
        import * as module0 from '$components/action_dialog_component.js';import * as module1 from '$components/call_to_action_component.js'
        const modules = {
            "action_dialog_component.js": module0,
            "call_to_action_component.js": module1,
        };
        export default modules;
      